import React from 'react';
import { IconProps } from '.';

const SvgHanger = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.75 7.643c0-.819.607-1.393 1.25-1.393s1.25.574 1.25 1.393c0 .819-.607 1.393-1.25 1.393a.75.75 0 0 0-.75.75v1.313L1.084 17.876 1.5 19.25h21l.416-1.374-10.166-6.777v-.67c1.18-.349 2-1.497 2-2.786 0-1.548-1.183-2.893-2.75-2.893S9.25 6.095 9.25 7.643h1.5ZM12 12.4l8.023 5.349H3.977L12 12.401Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHanger;
